import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { TaskDetailContent } from './task-detail-content';
import { CloseIcon } from './icons';

interface TaskDetailDialogProps {
  taskId: string | null;
  open: boolean;
  onClose: () => void;
}

export function TaskDetailDialog({ taskId, open, onClose }: TaskDetailDialogProps) {
  const [title, setTitle] = useState('Detail úlohy');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {taskId && <TaskDetailContent taskId={taskId} onTitleChange={setTitle} />}
      </DialogContent>
    </Dialog>
  );
}
